<template>
    <div>
        <buttonlist @help="help" @search="search" @exps="exps" @print="confirmPrint"
                    ref="SetBtn"></buttonlist>

        <div style="display: flex;background: white">
            <div style="width: 50%;text-align: left;display: flex">
                <el-button type="primary" size="mini" @click="add()">{{$t('getapi[6467]')}}</el-button>
                <el-button type="primary" size="mini" @click.native.prevent="selectsocode">{{$t('getapi[878]')}}
                </el-button>
                <el-button type="primary" size="mini" @click="deleteAll(0)">{{$t('getapi[4411]')}}</el-button>
                <el-button type="primary" size="mini" @click="deleteAll(1)">{{$t('getapi[7108]')}}</el-button>
            </div>
        </div>
        <div style="display: flex">
            <div style="width:30%">
                <el-table
                        id="xpane-0"
                        :data="datajson"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        @selection-change="handleSelectionChange"
                        :row-class-name="tableRowClassName"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column prop="so_code" :label="$t('getapi[4285]')" width="150">
                        <template scope="scope">
                            <el-input v-model="scope.row.so_code" type="text"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="width:70%">
                <el-table
                        id="xpane-1"
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column prop="so_code" :label="$t('getapi[4285]')" width="150"></el-table-column>
                    <el-table-column prop="part_code" :label="$t('getapi[112]')" width="150"></el-table-column>
                    <el-table-column prop="part_version" :label="$t('getapi[149]')" width="150"></el-table-column>
                    <el-table-column prop="measure_unit" :label="$t('getapi[888]')" width="150"></el-table-column>
                    <el-table-column prop="qty" :label="$t('getapi[1628]')" width="150"></el-table-column>
                </el-table>
            </div>
        </div>

        <!--发料单号红字弹窗-->
        <selectorvxe :isVisible="false" :isBatch=true :isSplitPage=true :postUrl="'/Pro/SoRelation/GetSoCodePartPopupList'" @callback="getsocode" ref="socode"></selectorvxe>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: '3_materialbyso',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                fileList: [],
                itevisible: false,
                tabIndex: '0',
                ids: '',
                showloading: '',
                DbTbNames: '', //表名
                datajson: [],
                datajsonremark: [],
                datajsonliu: [],
                loading: false, // 主表加载状态
                drosele: 0,
                droseleliu: 0,
                total1: 0,
                btn: {
                    //添加
                    Add: true,
                    //移除
                    Remove: false,
                    //导入
                    Import: true
                },
                scrollTop:0,
                orderby:1,
            };
        },
        create() {
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            this.btnauthority();
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            this.$nextTick(() => {
                addEventListener('paste', this.keyPaste);//创建键盘粘贴监听事件
            });
            this.authority();
            this.btnauthority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        beforeDestroy() {
            removeEventListener('paste', this.keyPaste);
        },
        methods: {
            keyPaste(e) {
                let that = this;
                if (this.$route.name == this.$options.name) {
                    if (e.clipboardData) {
                        var data = e.clipboardData.getData('Text');
                        if (!that.$limits.fnIsEmpty(data)) {
                            that.check(data);
                        }
                    }
                }
            },
            keyPasteButton() {
                let that = this
                let data = window.clipboardData.getData('Text');
                if (!that.$limits.fnIsEmpty(data)) {
                    that.check(data);
                }
            },
            check(datap) {
                //校验
                let that = this;
                let str = JSON.stringify(datap)
                str = str.replace('"', '').replace('"', '')
                let arr = str.split("\\r\\n")
                for (let i = 0; i < arr.length - 1; i++) {
                    if (arr[i].split('\\t').length == 1) {
                        that.datajson = [...that.datajson, {
                            so_code: arr[i].split('\\t')[0],
                        }]
                    }
                }
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4945]"),this.$t("getapi[25]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,export');

            },
            btnauthority() {
                let that = this;
            },
            deleteAll(e) {
                let that = this;
                if (e == 0) {
                    for (let i = that.selectIDData.length - 1; i >= 0; i--) {
                        that.datajson.splice(that.selectIDData[i].index, 1);
                    }
                } else {
                    that.datajson = [];
                }
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = val;
            },
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
            },
            add() {
                let that = this
                that.datajson = [...that.datajson, {
                    so_code: '',
                }]
            },
            selectsocode(){
                let that = this;
                that.$refs.socode.clearInput(true);
            },
            getsocode(data){
                let that = this
                console.log(data)
                for(let i=0;i<data.length;i++){
                    that.datajson = [...that.datajson,{
                        so_code : data[i].so_code
                    }]
                }
            },
            search() {
                let that = this;
                let parm = {
                    "PageIndex": 1,
                    "PageSize": 100000,
                    "SelectIndex": 0,
                    "Ids": '',
                    "Param": [],
                    "LangType": 0,
                    "fromname": that.$t("getapi[13356]")
                }
                let arr = []
                for(let i = 0;i<that.datajson.length;i++){
                    arr = [...arr,{
                        so_code: that.datajson[i].so_code
                    }]
                }
                that.loading = true
                parm.Param = arr
                parm.LangType= that.$processdata.getLang();
                that.$http.urlpost('/Fin/Wip/GetMaterialBySo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent
                    }
                    that.loading = false
                });
            },
            exps(){
                let that = this
                let arr = []
                for(let i = 0;i<that.datajson.length;i++){
                    arr = [...arr,{
                        so_code: that.datajson[i].so_code
                    }]
                }
                let parm = arr
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Fin/Wip/GetMaterialBySoToExcel', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    span.label-fade-enter {
        font-size: medium;
        margin-right: 20px;
    }
</style>
<style>
    .el-message-box {
        width: 600px;
    }
</style>
